export const genders = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  // { label: "Uni", value: "unisex" },
];

export const genderValues = genders.map((gen) => gen.value);
